import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73d862fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "203px"
  }
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_4 = {
  class: "student-analysis mohu"
};
const _hoisted_5 = {
  "element-loading-text": "数据加载中...",
  class: "charts-one charts"
};
const _hoisted_6 = {
  "element-loading-text": "数据加载中...",
  class: "charts-two charts"
};
const _hoisted_7 = {
  "element-loading-text": "数据加载中...",
  class: "charts-three charts"
};
const _hoisted_8 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
import { Bell } from "@element-plus/icons-vue";
import { onMounted, ref, watch, toRef } from "vue";
import * as Echarts from "echarts";
import { studentAnalysis, volunteerCount } from "@/api/api";
import { decrypt } from "@/utils/parseDate";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
export default {
  __name: 'StudentAnalysis',
  props: {
    majorId: String
  },
  emits: ["onChange"],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    const store = useStore();
    // 将 myMethod 暴露给父组件
    __expose({
      childMethod
    });
    function childMethod() {
      getStudentAnalysis();
      // getVolunteerCount();
    }
    // 点击解锁
    function onUnlock() {
      emit("onChange", {
        isUnlock: true
      });
    }
    const loading = ref(false);

    // 当年,历年分布
    const type = ref("1");
    // 图表数据
    const chartData = ref([]);
    onMounted(() => {
      getStudentAnalysis();
      // getVolunteerCount();
    });
    // 是否显示模糊效果
    const isUnlock = ref(false);
    const count = ref(0);
    // 今年新增多少人将该学校专业加入志愿
    async function getVolunteerCount() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await volunteerCount(data);
        const res = JSON.parse(decrypt(result));
        console.log(res, 'count');
        if (res.status === 0 && res.result) {
          count.value = res.result == null ? 0 : res.result;
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    // 获取考生分析数据
    async function getStudentAnalysis() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await studentAnalysis(data);
        const res = JSON.parse(decrypt(result));
        console.log(res);
        if (res.status == 8) {
          store.commit("setTipsDialog", true);
        }
        if (res.status == 9) {
          store.commit("setNumberDialog", true);
        }
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          let obj = [{
            name: "考生生源专业",
            data: [{
              name: "今年分布(预测)",
              data: [{
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }]
            }, {
              name: "往年分布",
              data: [{
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }]
            }]
          }, {
            name: "考生生源层次",
            data: [{
              name: "今年分布(预测)",
              data: [{
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }]
            }, {
              name: "往年分布",
              data: [{
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }]
            }]
          }, {
            name: "考生生源一、二战比例",
            data: [{
              name: "今年分布(预测)",
              data: [{
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }]
            }, {
              name: "往年分布",
              data: [{
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }, {
                num: "20",
                name: "请解锁查看"
              }]
            }]
          }];
          loading.value = false;
          initChartOne(obj[0]);
          initChartTwo(obj[1]);
          initChartThree(obj[2]);
        }
        if (res.status === 0 && res.result) {
          chartData.value = res.result;
          initChartOne(res.result[0]);
          initChartTwo(res.result[1]);
          initChartThree(res.result[2]);
          loading.value = false;
          isUnlock.value = false;
        }
        loading.value = false;
      } catch (error) {
        loading.vlaue = false;
        // throw new Error(error)
      }
    }

    // 改变查看类型
    function typeChange() {
      if (chartData.value.length > 0) {
        initChartOne(chartData.value[0]);
        initChartTwo(chartData.value[1]);
        initChartThree(chartData.value[2]);
      }
    }

    // 初始化图标
    function initChartOne(obj) {
      const findObj = type.value == "1" ? obj.data.find(ele => ele.name === "今年分布(预测)") : obj.data.find(ele => ele.name === "往年分布");
      console.log(findObj);
      const last = findObj.data.map(ele => ele.num);
      console.log(last);
      const xAxis = findObj.data.map(ele => ele.name);
      console.log(xAxis);
      const myChart = Echarts.init(document.querySelector(".charts-one"));
      myChart.setOption({
        title: {
          text: obj.name,
          subtext: findObj.name
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function (params) {
            let relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += "<br/>" + params[i].marker + params[i].name + " : " + params[i].value + "%";
            }
            return relVal;
          }
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: xAxis,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0 // 强制显示所有标签
          }
        }],

        yAxis: [{
          type: "value",
          axisLabel: {
            formatter: "{value}%"
          }
        }],
        series: [{
          name: obj.name,
          type: "bar",
          barWidth: "50%",
          data: last
        }]
      });
    }
    function initChartTwo(obj) {
      const myChart = Echarts.init(document.querySelector(".charts-two"));
      const findObj = type.value == "1" ? obj.data.find(ele => ele.name === "今年分布(预测)") : obj.data.find(ele => ele.name === "往年分布");
      const last = findObj.data.map(ele => ele.num);
      const xAxis = findObj.data.map(ele => ele.name);
      myChart.setOption({
        title: {
          text: obj.name,
          subtext: findObj.name
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function (params) {
            let relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += "<br/>" + params[i].marker + params[i].name + " : " + params[i].value + "%";
            }
            return relVal;
          }
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: xAxis,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0 // 强制显示所有标签
          }
        }],

        yAxis: [{
          type: "value",
          axisLabel: {
            formatter: "{value}%"
          }
        }],
        series: [{
          name: obj.name,
          type: "bar",
          barWidth: "50%",
          data: last
        }]
      });
    }
    function initChartThree(obj) {
      const myChart = Echarts.init(document.querySelector(".charts-three"));
      const findObj = type.value == "1" ? obj.data.find(ele => ele.name === "今年分布(预测)") : obj.data.find(ele => ele.name === "往年分布");
      const last = findObj.data.map(ele => ele.num);
      const xAxis = findObj.data.map(ele => ele.name);
      myChart.setOption({
        title: {
          text: obj.name,
          subtext: findObj.name
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function (params) {
            let relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += "<br/>" + params[i].marker + params[i].name + " : " + params[i].value + "%";
            }
            return relVal;
          }
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: xAxis,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0 // 强制显示所有标签
          }
        }],

        yAxis: [{
          type: "value",
          axisLabel: {
            formatter: "{value}%"
          }
        }],
        series: [{
          name: obj.name,
          type: "bar",
          barWidth: "50%",
          data: last
        }]
      });
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_Key = _resolveComponent("Key");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_el_select, {
        modelValue: type.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => type.value = $event),
        size: "large",
        onChange: typeChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "今年分布(预测)",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "往年分布",
          value: "0"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [[_directive_loading, loading.value]]), _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [[_directive_loading, loading.value]]), _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_button, {
        type: "success",
        onClick: onUnlock
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_Key)]),
          _: 1
        }), _createTextVNode(), _hoisted_9]),
        _: 1
      })])) : _createCommentVNode("", true)])], 64);
    };
  }
};